import { request } from './http';

export async function getMonthlyPwsSummary(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.siteId != null && params.siteId !== '') {
      queryParams.append('siteId', params.siteId);
    }
    const query = queryParams.toString();
    return request(`/data/monthly-pws-summary${query ? `?${query}` : ''}`);
  }

export async function createMonthlyPwsSummary(summaryData) {
    return request('/data/monthly-pws-summary', {
      method: 'POST',
      body: JSON.stringify(summaryData)
    });
  }

export async function updateMonthlyPwsSummary(id, summaryData) {
    return request(`/data/monthly-pws-summary/${id}`, {
      method: 'PUT',
      body: JSON.stringify(summaryData)
    });
  }

export async function deleteMonthlyPwsSummary(id) {
    return request(`/data/monthly-pws-summary/${id}`, {
      method: 'DELETE'
    });
  }

export const monthlyReclaimedAnalyticalDataSummaryApi = {
  getMonthlyPwsSummary,
  createMonthlyPwsSummary,
  updateMonthlyPwsSummary,
  deleteMonthlyPwsSummary,
};

